import { render } from "./Questionnaire.vue?vue&type=template&id=1e52d19d"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\survey_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__